<template>
  <el-dialog
    :title="title"
    :visible.sync="innerVisible"
    width="1250px"
    top="10vh"
    @close="onClose"
  >
    <div class="header-search">
      <el-form inline :model="searchData">
        <el-form-item label="方案名称">
          <el-input
            v-model.trim="searchData.comboName"
            size="small"
            placeholder="请输入"
            class="search-form-item"
          />
        </el-form-item>
        <el-form-item label="总期数">
          <el-input-number
            v-model="searchData.billNum"
            size="small"
            placeholder="请输入"
            :controls="false"
            :min="1"
            class="search-form-item"
          />
        </el-form-item>
        <el-form-item label="首付比例">
          <el-input
            v-model.trim="searchData.prepayRate"
            placeholder="请输入"
            size="small"
            clearable
            class="search-form-item"
          />
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="primary" size="small" icon="el-icon-search" @click="onSearch">
            搜索
          </el-button>
          <el-button type="info" size="small" icon="el-icon-refresh" @click="onReset">
            重置
          </el-button>
        </el-form-item>
      </el-form>
    </div>

    <el-tabs v-model="activeComboType" class="type-tabs" @tab-click="onComboTypeTab">
      <el-tab-pane label="常规方案" :name="String(enumComboType.A)" />
      <el-tab-pane label="返点方案" :name="String(enumComboType.B)" />
    </el-tabs>

    <el-table
      ref="comboTable"
      v-loading="tableLoading"
      :data="tableDisplayRows"
      row-key="id"
      border
      @selection-change="onTableSelectionChange"
    >
      <el-table-column
        v-if="mode === 'edit'"
        type="selection"
        width="55"
      />
      <el-table-column prop="id" label="ID" width="70" />
      <el-table-column prop="comboName" label="方案名称" min-width="140" />
      <el-table-column label="方案类型" width="100">
        <template slot-scope="scope">{{
          scope.row.comboTypeName || comboTypeText(scope.row.comboType)
        }}</template>
      </el-table-column>
      <el-table-column prop="billNum" label="期数" width="90">
        <template slot-scope="scope">{{ scope.row.billNum }}期</template>
      </el-table-column>
      <el-table-column prop="priceRate" label="费率" width="90">
        <template slot-scope="scope">{{ scope.row.priceRate }}%</template>
      </el-table-column>
      <el-table-column prop="prepayRate" label="首付比例" width="100">
        <template slot-scope="scope">{{ scope.row.prepayRate }}%</template>
      </el-table-column>
      <el-table-column prop="remark" label="备注" min-width="150" />
    </el-table>

    <div class="pagination-wrapper">
      <el-pagination
        background
        layout="prev, pager, next"
        :current-page.sync="page.currentPage"
        :page-size="page.pageSize"
        :total="paginationTotal"
      />
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="onClose">返回</el-button>
      <el-button v-if="mode === 'edit'" type="primary" size="small" @click="onSubmit">
        保存
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import { EnumComboType, ComboTypeToTextMap } from "@/enum/dict/index.js";
import { getComboList } from "../../combo/api.js";
import { getComboTemplateDetail } from "../api.js";

export default {
  name: "TemplatePlanDialog",
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    mode: {
      type: String,
      default: "detail",
    },
    /** 详情模式：模板 id，用于拉取 /admin/store/combo/tpl/detail */
    templateId: {
      type: [Number, String],
      default: null,
    },
    selectedIds: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      innerVisible: false,
      /** 程序化同步表格勾选时忽略 selection-change，避免循环更新 */
      syncingTableSelection: false,
      innerSelectedIds: [],
      /** 编辑模式：接口分页行缓存，用于提交时带出方案名称 */
      rowCache: {},
      tableLoading: false,
      enumComboType: EnumComboType,
      activeComboType: String(EnumComboType.A),
      searchData: {
        comboName: "",
        billNum: undefined,
        prepayRate: undefined,
      },
      appliedSearchData: {
        comboName: "",
        billNum: undefined,
        prepayRate: undefined,
      },
      page: {
        currentPage: 1,
        pageSize: 10,
      },
      listTotal: 0,
      tableRows: [],
      /** 详情模式：已选方案行数据 */
      detailRows: [],
    };
  },
  computed: {
    paginationTotal() {
      return this.mode === "detail" ? this.filteredDetailRows.length : this.listTotal;
    },
    tableDisplayRows() {
      return this.mode === "detail" ? this.pagedDetailRows : this.tableRows;
    },
    filteredDetailRows() {
      const typeNum = Number(this.activeComboType);
      const { comboName, billNum, prepayRate } = this.appliedSearchData;
      const hasPrepayRate = prepayRate != null && prepayRate !== "";
      return this.detailRows.filter((item) => {
        const matchType = item.comboType === typeNum;
        const matchName = !comboName || (item.comboName && item.comboName.includes(comboName));
        const matchBillNum = !billNum || item.billNum === billNum;
        const matchPrepayRate =
          !hasPrepayRate ||
          (item.prepayRate != null &&
            item.prepayRate !== "" &&
            Number(item.prepayRate) === Number(prepayRate));
        return matchType && matchName && matchBillNum && matchPrepayRate;
      });
    },
    pagedDetailRows() {
      const start = (this.page.currentPage - 1) * this.page.pageSize;
      return this.filteredDetailRows.slice(start, start + this.page.pageSize);
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.innerVisible = val;
        if (val) {
          this.resetSearchData();
          if (this.mode === "detail") {
            this.loadDetailRows();
          } else {
            this.innerSelectedIds = [...this.selectedIds];
            this.fetchComboList();
          }
        }
      },
    },
    selectedIds: {
      handler(val) {
        if (this.mode !== "edit") {
          return;
        }
        this.innerSelectedIds = [...val];
        if (this.visible) {
          this.$nextTick(() => this.syncEditTableSelection());
        }
      },
    },
    "page.currentPage"() {
      if (this.mode === "edit") {
        this.fetchComboList();
        return;
      }
      if (this.pagedDetailRows.length === 0 && this.page.currentPage > 1) {
        this.page.currentPage -= 1;
      }
    },
  },
  methods: {
    comboTypeText(comboType) {
      return ComboTypeToTextMap.get(comboType) || "";
    },
    mergeRowCache(list) {
      const next = { ...this.rowCache };
      (list || []).forEach((row) => {
        if (row && row.id != null) {
          next[row.id] = row;
        }
      });
      this.rowCache = next;
    },
    async fetchComboList() {
      // 替换 tableRows 时表格会先清空 selection 并触发 selection-change；若此时合并逻辑运行会误删 innerSelectedIds 里本页 id
      if (this.mode === "edit") {
        this.syncingTableSelection = true;
      }
      this.tableLoading = true;
      try {
        const res = await getComboList({
          page: this.page.currentPage,
          pageSize: this.page.pageSize,
          comboName: this.searchData.comboName || undefined,
          billNum: this.searchData.billNum,
          prepayRate: this.searchData.prepayRate,
          comboType: Number(this.activeComboType),
          status: null,
        });
        const list = res.list || [];
        this.tableRows = list;
        this.listTotal = res.total || 0;
        this.mergeRowCache(list);
      } finally {
        this.tableLoading = false;
        await this.$nextTick();
        await this.$nextTick();
        this.syncEditTableSelection();
      }
    },
    async loadDetailRows() {
      if (this.templateId == null || this.templateId === "") {
        this.detailRows = [];
        this.innerSelectedIds = [];
        return;
      }
      this.tableLoading = true;
      try {
        const res = await getComboTemplateDetail({ id: this.templateId });
        const list = res?.comboList || [];
        this.detailRows = list;
        this.innerSelectedIds = list.map((item) => item.id).filter((id) => id != null);
      } finally {
        this.tableLoading = false;
      }
    },
    resetSearchData() {
      this.searchData = {
        comboName: "",
        billNum: undefined,
        prepayRate: undefined,
      };
      this.appliedSearchData = {
        comboName: "",
        billNum: undefined,
        prepayRate: undefined,
      };
      this.activeComboType = String(EnumComboType.A);
      this.page.currentPage = 1;
      this.rowCache = {};
      this.tableRows = [];
      this.listTotal = 0;
      this.detailRows = [];
    },
    /**
     * tab-click 第一个参数为 ElTabPane 实例，用其 name 与当前方案类型对齐后再请求（与 v-model 一致，避免偶发竞态）。
     */
    onComboTypeTab(tab) {
      this.page.currentPage = 1;
      if (this.mode !== "edit") {
        return;
      }
      if (tab && tab.name != null) {
        this.activeComboType = String(tab.name);
      }
      this.fetchComboList();
    },
    onSearch() {
      this.appliedSearchData = {
        comboName: this.searchData.comboName,
        billNum: this.searchData.billNum,
        prepayRate: this.searchData.prepayRate,
      };
      this.page.currentPage = 1;
      if (this.mode === "edit") {
        this.fetchComboList();
      }
    },
    onReset() {
      this.resetSearchData();
      if (this.mode === "detail") {
        this.loadDetailRows();
      } else {
        this.fetchComboList();
      }
    },
    /** 兼容 number / string id */
    isIdInSelection(id) {
      return this.innerSelectedIds.some(
        (x) => x === id || String(x) === String(id),
      );
    },
    syncEditTableSelection() {
      const table = this.$refs.comboTable;
      if (!table || this.mode !== "edit") {
        this.syncingTableSelection = false;
        return;
      }
      this.syncingTableSelection = true;
      table.clearSelection();
      (this.tableDisplayRows || []).forEach((row) => {
        if (row && this.isIdInSelection(row.id)) {
          table.toggleRowSelection(row, true);
        }
      });
      // 延后解除：clearSelection/toggle 会异步触发 selection-change，过早放开会误合并空数组并丢掉本页勾选
      this.$nextTick(() => {
        this.$nextTick(() => {
          setTimeout(() => {
            this.syncingTableSelection = false;
          }, 50);
        });
      });
    },
    /**
     * 服务端分页下，用 innerSelectedIds 合并「当前页」勾选，避免丢其它页
     */
    onTableSelectionChange(selection) {
      if (this.mode !== "edit" || this.syncingTableSelection) {
        return;
      }
      const currentPageIds = (this.tableDisplayRows || []).map((r) => r.id);
      const selectedOnPage = (selection || []).map((r) => r.id);
      const rest = this.innerSelectedIds.filter(
        (id) => !currentPageIds.some((cid) => cid === id || String(cid) === String(id)),
      );
      this.innerSelectedIds = Array.from(new Set([...rest, ...selectedOnPage]));
      this.mergeRowCache(selection || []);
    },
    buildSubmitPayload() {
      return this.innerSelectedIds.map((id) => ({
        id,
        comboName: this.rowCache[id]?.comboName || "",
      }));
    },
    onSubmit() {
      this.$emit("submit", [...this.innerSelectedIds], this.buildSubmitPayload());
    },
    onClose() {
      this.$emit("update:visible", false);
      this.$emit("close");
    },
  },
};
</script>

<style lang="scss" scoped>
.search-form-item {
  width: 180px;

  /deep/ input {
    text-align: left;
  }
}

.type-tabs {
  margin-bottom: 12px;
}

.pagination-wrapper {
  margin-top: 12px;
  display: flex;
  justify-content: flex-end;
}

</style>
